import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { bookService } from '../services/bookService.js'

export const getAllBooks = createAsyncThunk(
  'book/getAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await bookService.getAll(params)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneBook = createAsyncThunk(
  'book/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await bookService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createBook = createAsyncThunk(
  'book/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await bookService.createBook(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const editBook = createAsyncThunk('book/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await bookService.editBook(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const deleteBook = createAsyncThunk(
  'book/delete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await bookService.deleteOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'books',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllBooks.pending]: (state) => {
      if (!state.data?.data?.length) {
        state.loading = true
      }
    },
    [getAllBooks.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllBooks.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneBook.pending]: (state) => {
      state.loading = true
    },
    [getOneBook.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneBook.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createBook.pending]: (state) => {
      state.loading = true
    },
    [createBook.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createBook.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [editBook.pending]: (state) => {
      state.loading = true
    },
    [editBook.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [editBook.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteBook.pending]: (state) => {
      state.loading = true
    },
    [deleteBook.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteBook.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
